import type { AuthFeatures } from '@gozoki/api-types'
import type { StoreMeResponse, TokenResponse, UserReponse } from '../types/axios.types'

import { gozokiApi, gozokiApiWithAuth } from '../gozokiApi'

// Fonctionnalités d'auth ouvertes sur le backend, lues sans jeton avant toute connexion : l'app
// choisit entre connexion par téléphone et par email (kanban #1125).
export const fetchAuthFeatures = async () => {
  const response = await gozokiApi.get<AuthFeatures>('/auth/features')
  return response.data
}

// Request an authentication token with credentials
export const login = async ({ email, password }: { email: string; password: string }) => {
  const response = await gozokiApiWithAuth.post<TokenResponse>('/auth/login', {
    email,
    password,
  })
  return response.data
}

// Fetch current user with authentication
export const me = async () => {
  const response = await gozokiApiWithAuth.get<UserReponse>('/me')
  return response.data
}

// store-app étape 1 : demande d'un code de connexion à 4 chiffres pour un numéro sur une boutique.
// Le backend renvoie le code (affiché dans store-app en attendant l'envoi SMS).
export const requestStoreLoginCode = async ({
  storeId,
  phone,
}: {
  storeId: number
  phone: string
}) => {
  const response = await gozokiApiWithAuth.post<{ code: string }>('/auth/store-request-code', {
    storeId,
    phone,
  })
  return response.data
}

// store-app étape 2 : vérifie le code et récupère le token boutique.
export const verifyStoreLoginCode = async ({
  storeId,
  phone,
  code,
}: {
  storeId: number
  phone: string
  code: string
}) => {
  const response = await gozokiApiWithAuth.post<TokenResponse>('/auth/store-verify-code', {
    storeId,
    phone,
    code,
  })
  return response.data
}

// store-app : connexion par IP du device (sans saisie). Le backend résout la boutique via l'IP
// publique et renvoie un token boutique, ou 403 si l'IP n'est rattachée à aucune boutique.
export const resolveStoreByIp = async () => {
  const response = await gozokiApi.post<TokenResponse>('/auth/store-by-ip')
  return response.data
}

// back-office : émet un token boutique pour prévisualiser le store-app d'une boutique arbitraire.
// Contourne la whitelist d'IP (réservé aux admins authentifiés) — le token est ensuite injecté dans
// l'iframe store-app via `?token=`.
export const getStorePreviewToken = async (storeId: number) => {
  const response = await gozokiApiWithAuth.post<TokenResponse>(
    `/auth/store-preview-token/${storeId}`,
  )
  return response.data
}

// store-app : récupère la boutique connectée
export const meStore = async () => {
  const response = await gozokiApiWithAuth.get<StoreMeResponse>('/store/me')
  return response.data
}
